const RiskIndicationDefinition = {
    LOW: 1,
    MIDDLE: 2,
    HIGH: 3
};

export default RiskIndicationDefinition;
